// extracted by mini-css-extract-plugin
export default {"container":"AddFaq_container__Px762","heading":"AddFaq_heading__pGi3q","form":"AddFaq_form__UO6kr","buttonContainer":"AddFaq_buttonContainer__w9QqM"};